import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./help.svg"; export default path + "#$"